import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { RootDispatch, RootState } from 'storage/store';
import { apiEvents, events } from '../utils/Api/Api';

const useFetchSystemMessage = (messageKey: string) => {
  const dispatch = useDispatch<RootDispatch>();
  const htmlContent = useSelector(
    (state: RootState) => state.application?.htmlContent
  );
  const loadMessage = async () => {
    const response = await dispatch.application.getSystemMessageByKey(
      messageKey
    );
    if (!response || !response.data) {
      console.error('No data returned from backend');
      events.emit(apiEvents.GENERAL_ERROR);
    }
    if (response) {
      const { data } = response;
      dispatch.application.addHtmlContent({
        ...data
      });
    }
  };
  useEffect(() => {
    loadMessage();
  }, [dispatch, messageKey]);
  const htmlMessage = htmlContent?.find(
    (item) => item.messageKey === messageKey
  );
  return { message: htmlMessage?.content };
};

export default useFetchSystemMessage;
